import React, { FunctionComponent } from 'react'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import { PrimaryButtonLink } from 'components/Buttons'
import AdjustLink from 'components/utils/adjust-link'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import { container } from './index.module.scss'

export interface RTFContentfulDownloadCtaGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulDownloadCta
  buttonText: string
}

export interface ContentfulDownloadCtaBlockProps
  extends RTFBlockComponentProps {
  buttonText: string
}

const ContentfulDownloadCtaBlock: FunctionComponent<ContentfulDownloadCtaBlockProps> = ({
  buttonText,
}) => {
  return (
    <div className={container}>
      <AdjustLink preferAndroidStore={false}>
        {(url: string) => <PrimaryButtonLink path={url} text={buttonText} />}
      </AdjustLink>
    </div>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulDownloadCtaBlock,
  isValid: ({ buttonText }) => !!buttonText,
}

export default componentExport
